import React from "react";
import Styles from "../ConnectionAcceptModal/ConnectionAcceptModal.module.css";
import { CircularProgress, Modal } from "@mui/material";
import { ReactComponent as ErrorIcon } from "../../../../assets/images/IconError.svg";

const WithdrawModal = ({
  open,
  handleClose,
  onConfirm,
  isInConnect,
  loading = false,
}) => {
  return (
    <Modal open={open} onClose={!loading ? handleClose : undefined}>
      <div className={Styles.createEditModalCont}>
        <div className={`headingText ${Styles.withdrawText}`}>Withdraw</div>

        <div className={`${Styles.headerSection} ${Styles.withdrawSection}`}>
          <ErrorIcon style={{ width: "60px", height: "60px" }} />

          <div className={Styles.releaseHead}>
            <span>
              Do you want to{" "}
              <span
                style={{
                  fontWeight: "500",
                  color: "var(--warning-shade-text)",
                }}
              >
                withdraw
              </span>{" "}
              this
            </span>
            <div>{isInConnect ? "connection request?" : "listing?"}</div>
          </div>
        </div>

        <div className={Styles.buttonSection}>
          {/* NO */}
          <div
            onClick={!loading ? handleClose : undefined}
            className={loading ? Styles.disabledBtn : ""}
          >
            <span className={Styles.onHoverButton}>
              {/* {loading ? <CircularProgress size={18} /> : "No"} */}
              No
            </span>
          </div>

          {/* YES */}
          <div
            onClick={!loading ? onConfirm : undefined}
            className={loading ? Styles.disabledBtn : ""}
          >
            <span
              className={Styles.onHoverButton}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              {loading ? (
                <>
                  {/* <CircularProgress size={18} /> */}
                  <span>Processing...</span>
                </>
              ) : (
                "Yes"
              )}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WithdrawModal;
